// extracted by mini-css-extract-plugin
export default {"onboardingForm":"a95eeac21f4d","checkboxGroup":"b71b0b337140"};